import { api } from './client'

export interface StarBalance {
  user_id: string
  stars: number
  updated_at: string
}

export interface Transaction {
  id: string
  user_id: string
  type: 'purchase' | 'transfer_in' | 'transfer_out' | 'refund'
  stars: number
  balance_after: number
  description: string
  created_at: string
}

export interface Invoice {
  id: string
  from_user_id: string
  to_user_id: string
  price_stars: number
  description: string
  status: 'pending' | 'paid' | 'expired'
  created_at: string
  expires_at: string
}

export const paymentsApi = {
  getBalance: (): Promise<StarBalance> =>
    api.get('/v1/payments/balance'),

  transferStars: (toUserId: string, stars: number, message?: string): Promise<Transaction> =>
    api.post('/v1/payments/stars/transfer', { to_user_id: toUserId, stars, message }),

  listTransactions: (): Promise<{ transactions: Transaction[] }> =>
    api.get('/v1/payments/transactions'),

  listInvoices: (): Promise<{ invoices: Invoice[] }> =>
    api.get('/v1/payments/invoices'),

  payInvoice: (invoiceId: string): Promise<void> =>
    api.post(`/v1/payments/invoices/${invoiceId}/pay`, {}),

  getPremiumStatus: (): Promise<{ is_premium: boolean; expires_at?: string; subscription_id?: string }> =>
    api.get('/v1/payments/premium'),

  listPlans: (): Promise<{ plans: Array<{ id: string; name: string; price_stars: number; duration_days: number }> }> =>
    api.get('/v1/payments/plans'),

  subscribe: (planId: string): Promise<{ subscription_id: string }> =>
    api.post('/v1/payments/subscribe', { plan_id: planId }),

  cancelSubscription: (subId: string): Promise<void> =>
    api.delete(`/v1/payments/subscriptions/${subId}`),

  giftPremium: (recipientId: string, planId: string, message?: string): Promise<{ id: string }> =>
    api.post('/v1/payments/gifts', { recipient_id: recipientId, plan_id: planId, message }),

  claimGift: (giftId: string): Promise<void> =>
    api.post(`/v1/payments/gifts/${giftId}/claim`, {}),

  buyStars: (stars: number, chargeRef?: string): Promise<Transaction> =>
    api.post('/v1/payments/stars/buy', { stars, charge_ref: chargeRef ?? 'demo' }),
}
